'use strict'

import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import sites from '../../../config/sites-north-america.js'

/**
 * Retrieves the root category ID for a specific brand within a site.
 *
 * @param {string} siteId - The ID of the site to search within.
 * @param {string} brandId - The ID of the brand to find within the site.
 * @returns {string|null} The root category ID of the brand if found, otherwise null.
 */
const getRootCategoryId = (siteId, brandId) => {
    // Find the site by ID
    const config = getConfig()
    const site = sites.find((site) => site.id === siteId)

    if (!site) {
        console.error(`Site with ID ${siteId} not found.`)
        return null
    }

    // Find the brand by ID within the site's brands
    const brand = site.l10n.brands.find((brand) => brand.id === brandId)

    if (!brand) {
        console.error(`Brand with ID ${brandId} not found in site ${siteId}.`)
        return null
    }

    // Return the root category ID — prefer per-site value from sites.js over global env var fallback
    return brand.rootCategory || config.app[`ROOT_CATEGORY_ID_${brandId.toUpperCase()}`]
}

const getBrandDisplayName = (brandId, alias = 'ca') => {
    return `${
        brandId?.charAt(0)?.toUpperCase() + brandId?.slice(1)
    } Clothing ${alias?.toUpperCase()}`
}

export {getRootCategoryId, getBrandDisplayName}
